import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { AppRouter } from './AppRouter';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from './clients/ClientRegistry';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <AppRouter />
    </ApolloProvider>
  </React.StrictMode>
);

reportWebVitals();
